import characterData from "../data/character.json";
import { gsap } from "gsap";
import Cookies from "js-cookie";

export default class UI {
    constructor() {
        this.chIndex = 0;
        this.langEvent = new CustomEvent("onLangChange");
        this.init();
    }

    init() {
        this.chChange();
        this.gnav();
        this.changeLang();
        this.defaultLang();
        this.setLoader();
    }

    setLoader() {
        document.body.classList.add("-loaded");
        document.body.classList.add("-introready");

        setTimeout(() => {
            this.firstVisit();
        }, 2000);
    }

    firstVisit() {
        const visited = Cookies.get("visited");
        const modalbtn = document.querySelector(".js-visitmovieopen");
        const endOfToday = new Date(new Date().setHours(23, 59, 59, 59));

        if (!visited) {
            modalbtn.click();
            Cookies.set("visited", 1, { expires: endOfToday });
        }
    }

    defaultLang() {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        if (params.get("lang") === "en") {
            document.body.setAttribute("data-lang", "en");
            window.dispatchEvent(this.langEvent);
        }
    }

    changeLang() {
        const switchBtn = [...document.querySelectorAll(".js-switchlang")];

        switchBtn.forEach((btn) => {
            btn.addEventListener("click", () => {
                const lang = btn.getAttribute("data-switchlang");
                document.body.setAttribute("data-lang", lang);
                window.dispatchEvent(this.langEvent);
            });
        });
    }

    gnav() {
        const trigger = [...document.querySelectorAll(".js-gnav_open")];
        const close = [...document.querySelectorAll(".js-gnav_close")];
        const nav = document.querySelector(".js-gnav");
        const gnavmainph = document.querySelector(".js-gnavmainph");

        trigger.forEach((el) => {
            el.addEventListener("click", () => {
                document.body.classList.add("-lock");
                nav.classList.add("-active");
            });
        });

        close.forEach((el) => {
            el.addEventListener("click", () => {
                document.body.classList.remove("-lock");
                nav.classList.remove("-active");
            });
        });

        //mouseInteraction
        nav.addEventListener("mousemove", (e) => {
            gsap.to(gnavmainph, { y: (window.innerHeight / 2 - e.clientY) / 10, duration: 2 });
        });
    }

    chChange() {
        //メイン画像先読み
        characterData.forEach((el) => {
            const mainph = new Image();
            const nameph = new Image();
            const faceph = new Image();
            mainph.getAttribute("src", `/assets/img/top/character/${el.id}/ph_main.png`);
            nameph.getAttribute("src", el.nrw_name ? `/assets/img/top/character/${el.id}/txt_name_nrw.svg` : `/assets/img/top/character/${el.id}/txt_name.svg`);
            faceph.getAttribute("src", `/assets/img/top/character/${el.id}/ph_face.svg`);
        });

        const thumb = [...document.querySelectorAll(".character__list__item")];
        const pn = [...document.querySelectorAll(".character__pn__item")];
        const ch_wrap = document.querySelector(".js-chchange");
        const ch_bg = document.querySelector(".js-chchange_bg");
        const ch_main = document.querySelector(".js-chchange_main");
        const ch_catch = document.querySelector(".js-chchange_catch");
        const ch_name = document.querySelector(".js-chchange_name");
        const ch_name_en = document.querySelector(".js-chchange_nameen");
        const ch_face = document.querySelector(".js-chchange_face");
        const ch_cap = document.querySelector(".js-chchange_cap");
        let timer = null;

        const chswicth = (index) => {
            //reset timer
            clearTimeout(timer);
            ch_wrap.classList.remove("-inanim");

            timer = setTimeout(() => {
                ch_wrap.classList.add("-inanim");
            }, 1);

            const isJP = document.body.getAttribute("data-lang") === "jp";
            const ch = characterData[index];
            ch_wrap.setAttribute("data-character", ch.id);
            ch_bg.src = window.innerWidth <= 835 ? `assets/img/top/character/${ch.id}/ph_bg_nrw.svg` : `assets/img/top/character/${ch.id}/ph_bg.svg`;
            ch_main.src = `assets/img/top/character/${ch.id}/ph_main.png`;
            ch_catch.src = `assets/img/top/character/${ch.id}/txt_catch${isJP ? "" : "_en"}.svg`;
            ch_catch.setAttribute("alt", isJP ? ch.catch : ch.catch_en);
            ch_name.src = window.innerWidth <= 835 && ch.nrw_name ? `assets/img/top/character/${ch.id}/txt_name_nrw.svg` : `assets/img/top/character/${ch.id}/txt_name.svg`;
            ch_name.setAttribute("alt", ch.name);
            ch_face.src = `assets/img/top/character/${ch.id}/ph_face.png`;
            ch_cap.textContent = isJP ? ch.cap : ch.cap_en;
            ch_name_en.textContent = ch.name_en;

            thumb.forEach((el, _index) => {
                el.classList.remove("-active");

                if (_index === index) {
                    el.classList.add("-active");
                }
            });

            this.chIndex = index;

            timer = setTimeout(() => {
                //durationは後で調整
                ch_wrap.classList.remove("-inanim");
            }, 1500);
        };

        //初期化
        chswicth(0);

        thumb.forEach((el, index) => {
            el.addEventListener("click", () => {
                chswicth(index);
            });
        });

        //PREV / NEXT
        pn.forEach((el) => {
            el.addEventListener("click", () => {
                const increment = el.getAttribute("data-dir") === "next" ? 1 : -1;
                let next = this.chIndex + increment;

                if (next > characterData.length - 1) {
                    next = 0;
                }

                if (next < 0) {
                    next = characterData.length - 1;
                }

                chswicth(next);
            });
        });

        //LANGCHANGE
        window.addEventListener("onLangChange", () => {
            //console.log("langchange");
            chswicth(this.chIndex);
        });
    }
}
